var React = require('react');

function IconStar (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.31579 10.6442L11.2189 13L10.1832 8.56L13.6316 5.57263L9.09053 5.18737L7.31579 1L5.54105 5.18737L1 5.57263L4.44842 8.56L3.41263 13L7.31579 10.6442Z"}));
}

IconStar.defaultProps = {"viewBox":"0 0 14 14"};

module.exports = IconStar;

IconStar.default = IconStar;
